<template>
  <div class="modal">
    <div class="pull-right">
      <div class="btn-close" @click="close"></div>
    </div>
    <div class="content fancy-scroll" @scroll.passive="showScrollbar">
      <div class="tab overview">
        <div v-if="isLoading" class="content-loading">
          <LoadingSpinner :loadingCaption="'Updates werden geladen...'" />
        </div>
        <div v-else-if="isLogsVisible">
          <h2 class="name">Änderungen</h2>
          <div
            v-for="(update, index) in sortedUpdates"
            :key="index"
            class="block"
          >
            <h3 class="name">
              <div class="icon">
                {{ getAuthorName(update.author).substring(0, 1) }}
              </div>
              <span>
                <b>{{ getAuthorName(update.author) }}</b> hat
                {{ getAction(update) }}
              </span>
            </h3>
            <h4 class="time">
              {{ getFrontDateTimeFormat(update['time-start']) }}
            </h4>
            <template
              v-if="
                [
                  'database-share',
                  'database-update',
                  'timeseries-metadata-update',
                  'database-entry-update',
                  'database-update',
                ].includes(update['activity-values']['activity-type'])
              "
            >
              <p
                v-for="(updateLog, index) in update['activity-values']['edits']"
                :key="index"
              >
                {{ formatItemKey(updateLog['key']) }}
                <br />
                <span class="bg-red">
                  {{
                    updateLog['key'] === 'permission'
                      ? translatePermoission(updateLog['old-value'])
                      : updateLog['old-value']
                  }}
                </span>
                <template v-if="updateLog['old-value']"> &rarr; </template>
                <span class="bg-green">
                  {{
                    updateLog['key'] === 'permission'
                      ? translatePermoission(updateLog['new-value'])
                      : updateLog['new-value']
                  }}
                </span>
              </p>
            </template>
            <p
              v-if="
                'database-entry-create' ==
                update['activity-values']['activity-type']
              "
            >
              <br />
              <span class="bg-green">
                Eintrag:
                {{ getAddItemsLog(update) }}
              </span>
            </p>
            <p
              v-if="
                'database-entry-delete' ==
                update['activity-values']['activity-type']
              "
            >
              <br />
              <span class="bg-red">
                Eintrag:
                {{ getItemId(update) }}
              </span>
            </p>
            <p
              v-if="
                update['activity-values']['activity-type'] ==
                'timeseries-calculation'
              "
            >
              Alle Werte
              <span
                v-if="
                  update['activity-values']['edits'][0]['settings'].length > 0
                "
              >
                in dem folgenden Datenbereich:
                <span
                  class="bg-blue"
                  v-for="(item, index) in update['activity-values']['edits'][0][
                    'settings'
                  ]"
                  :key="index"
                  :class="{ inline: isRangeSelection(item.key) }"
                >
                  {{ formatItemKey(item.key, item.value) }} &rarr;
                  {{ formatItemValue(item.key, item.value) }}
                </span>
              </span>
              <b>
                {{ describeOperation(update['activity-values']['edits'][0]) }}
              </b>
              <!--
                Displays multiple changes in one update
                <ul v-else>
                  <li v-for="edit, index in update['activity-values']['edits']" :key="index" style="color: black">
                    <b>{{ describeOperation(edit) }}</b>
                  </li>
                </ul>
                -->
            </p>
            <p
              v-if="
                update['activity-values']['activity-type'] ==
                'timeseries-data-update'
              "
            >
              <span>
                folgende Werte angepasst:
                <br />
                <div
                  v-for="(dataPoint, index) in update['activity-values'][
                    'edits'
                  ][0]['changes']"
                  :key="index"
                >
                  {{ getFrontDateTimeFormat(dataPoint['timestamp']) }}
                  <span class="bg-red">
                    {{ getToFixedValue(dataPoint['old-value'], 2) }}
                  </span>
                  &rarr;
                  <span class="bg-green">
                    {{ getToFixedValue(dataPoint['new-value'], 2) }}
                  </span>
                </div>
              </span>
            </p>
          </div>
        </div>
        <div v-else class="no-data-img">
          <h3 style="text-align: center">Keine Updates vorhanden !</h3>
          <img src="../assets/img/nodata.svg" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LoadingSpinner from './widgets/LoadingSpinner.vue';
import { debouncer } from '../utils/helpers';
export default {
  name: 'updates',
  data() {
    return {
      dateOptions: {
        hour12: false,
        hour: '2-digit',
        minute: '2-digit',
        year: 'numeric',
        month: 'short',
        day: '2-digit',
        timeZone: 'CET',
      },
      authorNames: {},
      sortedUpdates: [],
      isLoading: true,
    };
  },
  props: {
    updates: {
      type: Array,
      default: null,
    },
    dbType: {
      type: String,
      default: '',
    },
  },
  methods: {
    async updateData(Updatesdata) {
      if (this.dbType === 'loadprofile') {
        this.isLoading = true;
        await this.getAllAuthorName(Updatesdata);
        this.sortUpdatesByCreated(Updatesdata);
      }
    },
    close() {
      this.$emit('close');
    },
    getFrontDateTimeFormat(value) {
      var temp = new Date(parseInt(value));
      return temp.toLocaleTimeString('de-DE', this.dateOptions);
    },
    getAuthorName(id) {
      if (this.authorNames.hasOwnProperty(id)) return this.authorNames[id];
      //ToDo: What do we do, if a user got deleted?
      else return 'Unknown';
    },
    async getUserNames(id) {
      var url = process.env.VUE_APP_DATA_API;
      url += '/users/' + encodeURIComponent(id);
      url += '/name';

      let myHeaders = new Headers();
      myHeaders.append(
        'Authorization',
        'Bearer ' + this.user.signInUserSession.accessToken.jwtToken
      );

      return await fetch(url, {
        method: 'GET',
        headers: myHeaders,
      })
        .then(async (response) => {
          if (response.status == 200) return response.json();
          else if (response.status == 401) {
            throw new Error('Access Token has expired');
          } else throw new Error('CORS');
        })
        .then(async (json) => {
          return json;
        })
        .catch(async (e) => {
          //TODO: If error CORS show modal (emit in parent)
          if (e == 'Error: Access Token has expired') {
            localStorage.clear(),
              this.$router.push({
                name: 'auth',
                params: { message: 'Sitzung abgelaufen' },
              });
            return false;
          }
          return '';
        });
    },
    getAction(update) {
      const typeToAction = {
        'timeseries-metadata-update': 'folgende Infos angepasst:',
        'timeseries-calculation': 'eine Operation durchgeführt:',
        'database-entry-update': 'folgende Infos angepasst:',
        'database-entry-create':
          update['activity-values']['edits'].length === 1
            ? 'einen neuen Eintrag erstellt'
            : 'neue Einträge erstellt',
        'database-entry-delete': 'einen Eintrag gelöscht',
        'timeseries-data-update': 'eine Operation durchgeführt:',
        'timeseries-data-update': 'eine Operation durchgeführt:',
        'database-update': 'eine Operation durchgeführt:',
      };
      if (
        update['activity-values']['activity-type'] === 'database-share' &&
        update['activity-values']['username']
      ) {
        let msg;
        const username = this.getAuthorName(
          update['activity-values']['username']
        );
        if (
          update['activity-values']['edits'][0]['old-value'] &&
          update['activity-values']['edits'][0]['new-value']
        ) {
          msg = `teilte die Datenbank mit ${username}`;
        } else if (update['activity-values']['edits'][0]['old-value']) {
          msg = `${username} den Datenbankzugriff entzogen.`;
        } else {
          msg = `die Datenbank an ${username} weitergegeben.`;
        }
        typeToAction['database-share'] = msg;
      }
      return typeToAction[update['activity-values']['activity-type']];
    },
    describeOperation(edit) {
      const operand = edit['operand'];
      const unit = this.getUnit(edit['unit']);
      switch (edit['operation']) {
        case 'multiply':
          return 'mit dem Faktor ' + operand + unit + ' multipliziert.';
        case 'add':
          return 'mit ' + operand + unit + ' erhöht.';
        case 'subtract':
          return 'mit ' + operand + unit + ' reduziert.';
        case 'divide':
          return 'durch ' + operand + unit + ' dividiert.';
        case 'scale':
          return 'auf eine Gesamtmenge von ' + operand + unit + ' skaliert.';
        case 'delete-negative-values':
          return 'negative Werte gelöscht';
      }
    },
    getUnit(unit) {
      if (unit != null) return ' ' + this.translateUnit(unit);
      else return '';
    },
    translateUnit(unit) {
      const translate = {
        percentage: 'Prozent',
        kWh_percentage: 'kWh Prozent',
      };
      return translate[unit] != undefined ? translate[unit] : unit;
    },
    formatItemValue(key, val) {
      if (key == 'start-time' || key == 'end-time') return val + ' Uhr';
      else if (key == 'start-date' || key == 'end-date')
        return this.getFrontDateTimeFormat(val);
      else if (Array.isArray(val)) return val.join(', ');
      else return val;
    },
    formatItemKey(key, value) {
      const translate = {
        days: 'Tage',
        months: 'Monate',
        quarters: 'Quartale',
        'start-time': 'von ',
        'end-time': 'bis ',
        'start-date': 'vom',
        'end-date': 'bis zum',
        description: 'Beschreibung',
        name: 'Name',
        permission: 'Berechtigung',
      };

      const elToHandleSingular = ['days', 'months', 'quarters'];

      // Handle Translation
      if (translate.hasOwnProperty(key)) {
        // For handleSingular we remove last char if only 1 value
        const isHandleSingular =
          elToHandleSingular.includes(key) && value.length == 1;

        if (!isHandleSingular) return translate[key];
        else return translate[key].substring(0, translate[key].length - 1);
      }

      return key;
    },
    isRangeSelection(key) {
      const rangeSelections = [
        'start-time',
        'end-time',
        'start-date',
        'end-date',
      ];
      return rangeSelections.includes(key);
    },
    sortUpdatesByCreated(logs) {
      this.sortedUpdates = JSON.parse(JSON.stringify(logs)).sort(
        (item_a, item_b) => {
          // Get timestamps
          let a = item_a['time-start'];
          let b = item_b['time-start'];

          // Compare
          return a < b ? 1 : b < a ? -1 : 0;
        }
      );
    },
    getItemId(log) {
      if (log['activity-values']['edits'][0])
        return log['activity-values']['edits'][0]['item-id'];
      else return '';
    },
    async getAllAuthorName(logs) {
      const authorsId = [];
      for (const e of logs) {
        authorsId.push(e.author);
        if (
          e['activity-values']['activity-type'] === 'database-share' &&
          e['activity-values']['username']
        ) {
          authorsId.push(e['activity-values']['username']);
        }
      }
      // Get names for updates
      const authors = [...new Set(authorsId)];
      for (const author of authors) {
        const name = await this.getUserNames(author);
        this.authorNames[author] = name;
      }
      this.isLoading = false;
    },
    getToFixedValue(value, fixedNumber) {
      return value.toFixed(fixedNumber);
    },
    showScrollbar(event) {
      event.target.classList.add('show-scrollbar');
      debouncer(
        () => {
          event.target.classList.remove('show-scrollbar');
        },
        300,
        this,
        'removeScrollClass'
      );
    },
    getAddItemsLog(log) {
      return log['activity-values']['edits']
        .map((item) => item['item-id'])
        .join(', ');
    },
    translatePermoission(key) {
      const translator = {
        read: 'Lesen',
        write: 'Schreiben',
        full_access: 'Vollzugriff',
      };
      return translator[key];
    },
  },
  async created() {
    if (this.dbType !== 'loadprofile') {
      this.$watch(
        'updates',
        function (newValue) {
          if (newValue) {
            this.getAllAuthorName(newValue);
            // Sort updates
            this.sortUpdatesByCreated(newValue);
          }
        },
        { deep: true, ...(this.dbType === 'custom' ? {} : { immediate: true }) }
      );
    }
  },

  computed: {
    user() {
      return this.$store.state.user;
    },
    isLogsVisible() {
      if (this.dbType === 'loadprofile') {
        return this.sortedUpdates.length != 0;
      } else {
        return this.updates.length != 0;
      }
    },
  },
  components: {
    LoadingSpinner,
  },
};
</script>

<style scoped>
/*
@import "https://cdn.jsdelivr.net/npm/pretty-checkbox@3.0/dist/pretty-checkbox.min.css";
*/

.modal {
  background: #ffffff;
  border-radius: 0px;
  display: block;
  width: 438px;
  text-align: left;
  font-family: 'Open Sans', open-sans, sans-serif;
  -webkit-font-smoothing: antialiased;
  font-size: 12px;
  line-height: 17px;
  color: #5f697a;
  top: 0;
  position: fixed;
  left: unset;
  top: 0;
  right: 0px;
  border-left: 1px solid #dee3e9;
  min-height: fit-content;
}
.content {
  width: max-content;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  background-color: #fff;
  border-radius: 7px;
  color: #22252b;
  overflow: scroll;
  transition: 0.5s;
  min-height: fit-content;
  height: 100%;
  margin-bottom: 30px;
  height: calc(100vh - 50px);
}

.tab {
  display: inline-block;
  margin-left: 30px;
  min-height: fit-content;
  margin-bottom: 80px;
  padding-left: 30px;
  padding-right: 30px;
}

.tab.overview {
  float: left;
  transition: width 0.5s;
  margin-bottom: 0;
}

h3 {
  color: rgba(85, 93, 109, 0.4);
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  margin-bottom: 10px;
}

h4 {
  color: rgba(85, 93, 109, 0.4);
  font-size: 11px;
  letter-spacing: 0.03em;
  margin-bottom: 0px;
}

.pull-right {
  position: relative;
  z-index: 3;
  transition: right 0.5s;
}

.modal:not(.custom) li {
  font-size: 14px;
  line-height: 25px;
  color: #7e8890;
}

p {
  font-weight: 500;
  font-size: 12px;
  line-height: 21px;
  color: #7e8890;
  margin: 25px 0px 25px 0px;
}

.pull-right {
  float: right;
  margin-right: 15px;
  margin-top: 15px;
}

:root {
  --color-pink: #f36;
  --color-pink-darker: #e81e61;
  --color-blue-lighter: #f5fbff;
  --color-blue: #276ee5;
  --color-blue-darker: #1f53d5;
  --color-green-lighter: #f2fbfa;
  --color-green: #09baa6;
  --color-green-darker: #00a08e;
  --color-yellow-lighter: #fffbf4;
  --color-yellow: #ffb631;
  --color-yellow-darker: #e8a01e;
  --color-red-lighter: #fdf3f5;
  --color-red: #e01e3d;
  --color-red-darker: #c60d2b;
  --color-ink-lightest: #9599a2;
  --color-ink-lighter: #6e7077;
  --color-ink: #22252b;
  --color-ink-darker: #17191d;
  --color-gray-lightest: #f8f8fa;
  --color-gray-lighter: #ebecee;
  --color-gray: #dee0e4;
  --color-gray-darker: #c7cad1;
  --color-black-lighter: #182237;
  --color-black: #15181f;
  --color-white: #fff;
  --elevation-low: 0 0 0 1px rgba(0, 0, 0, 0.05), 0 1px 2px rgba(0, 0, 0, 0.12);
  --elevation-medium: 0 0 0 1px rgba(0, 0, 0, 0.05),
    0 5px 10px rgba(0, 0, 0, 0.15);
  --elevation-high: 0 0 0 1px rgba(0, 0, 0, 0.05),
    0 10px 20px rgba(0, 0, 0, 0.15);
  --rounded: 4px;
  --circled: 50%;
  --pilled: 64px;
}

ul li {
  line-height: 17px;
}

li {
  display: list-item;
  text-align: -webkit-match-parent;
}

input[type='checkbox'],
input[type='radio'] {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 0;
  -webkit-font-smoothing: antialiased;
  outline: 0;
  margin: 0 0 9px;
  font-size: 100%;
  vertical-align: middle;
  display: inline-block;
}

.toolbar .more {
  margin-top: 8px;
}

.checker input,
.checker input[type='checkbox'] {
  cursor: pointer;
  visibility: visible;
  height: 21px;
  width: 20px;
  display: inline-block;
  background: 0 0;
  opacity: 0;
}

input[type='checkbox'],
input[type='radio'] {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 0;
  -webkit-font-smoothing: antialiased;
  outline: 0;
  margin: 0 0 9px;
  font-size: 100%;
  vertical-align: middle;
  display: inline-block;
}

.content {
  width: 100%;
  margin: 0;
  padding: 0;
}

.modal h2 {
  font-size: 15px !important;
  letter-spacing: 0.125px;
  font-weight: 500 !important;
  font-family: 'Inv Eina 03', 'Eina 03', -apple-system, BlinkMacSystemFont,
    'Open Sans', open-sans, sans-serif;
  line-height: 40px;
  color: #37352fa6;
  margin-top: 54px;
  margin-bottom: 10px;
}

.modal h3 {
  font-family: 'Inv Maison Neue', 'Maison Neue', -apple-system,
    BlinkMacSystemFont, 'Open Sans', open-sans, sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 39px;
  letter-spacing: 0.125px;
  color: rgb(34, 37, 43);
  margin-top: 20px;
  padding-bottom: 6px;
  font-weight: 700 !important;
  text-transform: none;
  margin-bottom: 0px;
}

.block {
  border-top: 1px solid #dee0e4;
  padding-bottom: 5px;
  overflow-wrap: anywhere;
}

.block h3.name {
  display: flex;
  gap: 15px;
}

.block h3.name span {
  /* padding-left: 15px; */
  font-size: 15px;
  line-height: normal;
  display: inline-block;
  width: calc(100% - 40px);
  max-width: 100%;
}

.block h3.name .icon {
  box-sizing: content-box;
  border: 1px solid currentcolor;
  border-radius: 100%;
  width: 26px;
  height: 26px;
  line-height: 26px;
  overflow: hidden;
  text-align: center;
  font-size: 14px;
  background: white;
  user-select: none;
  color: rgb(55, 53, 47);
  opacity: 1;
}

.block .bg-red {
  background-color: #fdebec;
}

.block .bg-green {
  background-color: #edf3ec;
}

.block .bg-yellow {
  background-color: #fbf3db;
}
.block .bg-blue {
  color: rgb(35, 131, 226);
  background-color: rgba(35, 131, 226, 0.14);
  display: block;
  width: fit-content;
}
.block .bg-blue.inline {
  display: inline;
}

.block p,
span {
  line-height: 21px;
  font-size: 14px;
  font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica,
    Arial, sans-serif, Inv Maison Neue, Apple Color Emoji, Segoe UI Emoji,
    Segoe UI Symbol;
  font-weight: 400;
  color: #000;
  background: #fff;
  -webkit-font-smoothing: antialiased;
}

.block a {
  font-weight: 300;
  letter-spacing: 0.18px;
  text-decoration: underline;
  line-height: 39px;
  height: 39px;
  font-size: 14px;
  cursor: pointer;
  margin-top: 50px;
}

.bottom {
  border-bottom-width: 2px;
  border-bottom-color: #000;
  border-bottom-style: solid;
}

.no-data-img {
  margin-top: 50px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.no-data-img img {
  max-width: 80%;
  margin-top: 50px;
}

::v-deep .content .content-loading .loading .progress-icon-wrapper span {
  margin-top: 40%;
  margin-left: 28%;
  margin-top: 100%;
  width: 200px;
}
::v-deep
  .content
  .content-loading
  .loading
  .progress-icon-wrapper
  .progress-icon {
  left: 47%;
  margin-top: 80%;
}
</style>
